import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
}
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center items-center py-8"
}
const _hoisted_3 = {
  key: 0,
  class: "ml-3 text-primary-text dark:text-primary-dark-text"
}
const _hoisted_4 = {
  key: 2,
  class: "flex justify-center items-center py-4"
}
const _hoisted_5 = {
  key: 0,
  class: "ml-2 text-sm text-primary-text dark:text-primary-dark-text"
}
const _hoisted_6 = {
  key: 3,
  class: "flex items-center justify-center"
}
const _hoisted_7 = {
  key: 0,
  class: "ml-2 text-sm"
}
const _hoisted_8 = {
  key: 4,
  class: "space-y-3"
}
const _hoisted_9 = {
  key: 5,
  class: "space-y-4"
}
const _hoisted_10 = {
  key: 6,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
}
const _hoisted_11 = {
  key: 7,
  class: "space-y-6"
}
const _hoisted_12 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_14 = { class: "space-y-6" }
const _hoisted_15 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4 animate-pulse" }
const _hoisted_16 = { class: "space-y-3" }
const _hoisted_17 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4 h-40 animate-pulse" }
const _hoisted_18 = { class: "grid grid-cols-7 gap-2" }
const _hoisted_19 = {
  key: 8,
  class: "animate-pulse"
}

import { computed } from 'vue'

export interface LoadingStateProps {
  isLoading: boolean
  type?: 'cards' | 'spinner' | 'compact' | 'inline' | 'table' | 'list' | 'stats' | 'custom' | 'dashboard'
  text?: string
  cardCount?: number
  tableRows?: number
  listItems?: number
  statsCount?: number
  containerClass?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingState',
  props: {
    isLoading: { type: Boolean, default: false },
    type: { default: 'spinner' },
    text: { default: '' },
    cardCount: { default: 6 },
    tableRows: { default: 5 },
    listItems: { default: 5 },
    statsCount: { default: 4 },
    containerClass: { default: '' }
  },
  setup(__props: any) {

const props = __props

// Default texts for different types
const defaultText = computed(() => {
  switch (props.type) {
    case 'cards':
      return ''
    case 'dashboard':
      return ''
    case 'spinner':
      return 'Loading...'
    case 'compact':
      return 'Loading...'
    case 'inline':
      return ''
    case 'table':
      return ''
    case 'list':
      return ''
    case 'stats':
      return ''
    case 'custom':
      return ''
    default:
      return 'Loading...'
  }
})

return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["loading-state", _ctx.containerClass])
      }, [
        (_ctx.type === 'cards')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardCount, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "animate-pulse"
                }, [...(_cache[0] || (_cache[0] = [
                  _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6\" data-v-1864dae2><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4 mb-4\" data-v-1864dae2></div><div class=\"h-3 bg-gray-200 dark:bg-gray-600 rounded w-1/2 mb-2\" data-v-1864dae2></div><div class=\"h-3 bg-gray-200 dark:bg-gray-600 rounded w-full mb-4\" data-v-1864dae2></div><div class=\"h-8 bg-gray-200 dark:bg-gray-600 rounded w-1/3\" data-v-1864dae2></div></div>", 1)
                ]))]))
              }), 128))
            ]))
          : (_ctx.type === 'spinner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary" }, null, -1)),
                (_ctx.text)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text || defaultText.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.type === 'compact')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "animate-spin rounded-full h-6 w-6 border-b-2 border-primary" }, null, -1)),
                  (_ctx.text)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.text || defaultText.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.type === 'inline')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "animate-spin rounded-full h-4 w-4 border-b-2 border-current" }, null, -1)),
                    (_ctx.text)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.text || defaultText.value), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.type === 'table')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableRows, (i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "animate-pulse"
                        }, [...(_cache[4] || (_cache[4] = [
                          _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4\" data-v-1864dae2><div class=\"grid grid-cols-4 gap-4\" data-v-1864dae2><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-1/2\" data-v-1864dae2></div></div></div>", 1)
                        ]))]))
                      }), 128))
                    ]))
                  : (_ctx.type === 'list')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "animate-pulse"
                          }, [...(_cache[5] || (_cache[5] = [
                            _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4\" data-v-1864dae2><div class=\"flex items-center space-x-4\" data-v-1864dae2><div class=\"rounded-full bg-gray-200 dark:bg-gray-600 h-12 w-12\" data-v-1864dae2></div><div class=\"flex-1 space-y-2\" data-v-1864dae2><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4\" data-v-1864dae2></div><div class=\"h-3 bg-gray-200 dark:bg-gray-600 rounded w-1/2\" data-v-1864dae2></div></div></div></div>", 1)
                          ]))]))
                        }), 128))
                      ]))
                    : (_ctx.type === 'stats')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsCount, (i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "animate-pulse"
                            }, [...(_cache[6] || (_cache[6] = [
                              _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6\" data-v-1864dae2><div class=\"flex items-center\" data-v-1864dae2><div class=\"rounded-md bg-gray-200 dark:bg-gray-600 h-12 w-12 mr-4\" data-v-1864dae2></div><div class=\"flex-1\" data-v-1864dae2><div class=\"h-6 bg-gray-200 dark:bg-gray-600 rounded w-16 mb-2\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-24\" data-v-1864dae2></div></div></div></div>", 1)
                            ]))]))
                          }), 128))
                        ]))
                      : (_ctx.type === 'dashboard')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsCount, (i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `dash-stat-${i}`,
                                  class: "animate-pulse"
                                }, [...(_cache[7] || (_cache[7] = [
                                  _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6\" data-v-1864dae2><div class=\"flex items-center\" data-v-1864dae2><div class=\"rounded-md bg-gray-200 dark:bg-gray-600 h-12 w-12 mr-4\" data-v-1864dae2></div><div class=\"flex-1\" data-v-1864dae2><div class=\"h-6 bg-gray-200 dark:bg-gray-600 rounded w-20 mb-2\" data-v-1864dae2></div><div class=\"h-5 bg-gray-200 dark:bg-gray-600 rounded w-24\" data-v-1864dae2></div></div></div></div>", 1)
                                ]))]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"lg:col-span-2 animate-pulse\" data-v-1864dae2><div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 h-72 mb-6\" data-v-1864dae2></div><div class=\"grid grid-cols-1 md:grid-cols-2 gap-6\" data-v-1864dae2><div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 h-28 animate-pulse\" data-v-1864dae2></div><div class=\"bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 h-28 animate-pulse\" data-v-1864dae2></div></div></div>", 1)),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "h-4 bg-gray-200 dark:bg-gray-600 rounded w-1/3 mb-3" }, null, -1)),
                                  _createElementVNode("div", _hoisted_16, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                      return _createElementVNode("div", {
                                        key: `act-${i}`,
                                        class: "flex items-center space-x-3"
                                      }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-600" }, null, -1),
                                        _createElementVNode("div", { class: "flex-1" }, [
                                          _createElementVNode("div", { class: "h-3 bg-gray-200 dark:bg-gray-600 rounded w-3/4 mb-2" }),
                                          _createElementVNode("div", { class: "h-2 bg-gray-200 dark:bg-gray-600 rounded w-1/2" })
                                        ], -1)
                                      ]))])
                                    }), 64))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "h-6 bg-gray-200 dark:bg-gray-600 rounded w-1/4 mb-4" }, null, -1)),
                                  _createElementVNode("div", _hoisted_18, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(21, (i) => {
                                      return _createElementVNode("div", {
                                        key: `cal-${i}`,
                                        class: "h-6 bg-gray-200 dark:bg-gray-600 rounded"
                                      })
                                    }), 64))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : (_ctx.type === 'custom')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _renderSlot(_ctx.$slots, "skeleton", {}, () => [
                                _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6\" data-v-1864dae2><div class=\"space-y-4\" data-v-1864dae2><div class=\"h-6 bg-gray-200 dark:bg-gray-600 rounded w-1/4\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-full\" data-v-1864dae2></div><div class=\"h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4\" data-v-1864dae2></div></div></div>", 1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})